import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Select } from '@rmwc/select';
import Scrollbar from "react-scrollbars-custom";
import { connect } from "react-redux";



class DoorWindowTextBottom extends Component {
  render() {
  return (
         <div className="section-seprator">
   <div>
      <p className="text-panelprimary f-12 roboto-bold mb-2">Components are added on the HIGHLIGHTED WALL on the building. Rotate to highlight the wall to place a component on it.</p>
   </div>
   {(this.props.params.add_left_lean==true || this.props.params.add_right_lean==true)?
   <div>
      <p className="text-panelprimary f-12 barlow-semibold mb-2"><span className="roboto-bold" >COMPONENT ON LEAN-TO</span> - Click on the <u>LEFT/RIGHT</u> tab from the Config Panel >> It will highlight the Wall on the Building with a colored border >> Choose the wall and Follow the steps to <u>ADD</u> the component on the highlighted wall.</p>
      <p className="text-panelprimary f-12 barlow-semibold mb-2">If you want to add the component on the <u>CENTER UNIT</u> – choose CENTER from the toggle shown below the building.</p>
      
   </div>:
   null
  }
   {(this.props.params.add_storage_check==true || this.props.params.add_storage_check_right==true || this.props.params.p_u_c==true)?
        <>
        <p className="text-panelprimary f-12 barlow-semibold mb-0"><span className="roboto-bold"  >COMPONENT ON UTILITY STORAGE</span> - Click on LEFT/RIGHT/CENTER tab which has utility storage >> <u>Check the STORAGE check box</u> and Follow the steps to <u>ADD</u> the component on the highlighted wall. </p>
      </>
      :null
    }
   </div>


      );
  }
}
const mapStoreToProps = (state) => {
  return state.reducer
  }
  
  
  export default connect(
  mapStoreToProps,
  )(DoorWindowTextBottom);
